<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="22" height="22" rx="4" fill="#929EA9" />
    <path
      d="M13.0599 3.27964C13.7399 3.45944 14.3799 3.71904 14.9799 4.07865C15.5799 4.43825 16.1399 4.8577 16.6399 5.35707C17.1399 5.85645 17.5599 6.41581 17.92 7.01506C18.2599 7.61431 18.5399 8.25345 18.72 8.93263C18.9 9.61181 19 10.3109 19 11.0101C19 11.3296 18.98 11.6693 18.9399 11.9889C18.9399 12.0288 18.92 12.0688 18.92 12.1087C18.88 12.4482 18.8 12.7679 18.72 13.0676C18.5399 13.7467 18.2599 14.3859 17.92 14.9851C17.5599 15.5844 17.1399 16.1437 16.6399 16.6431L14.8 14.8055C15.56 14.0464 16.06 13.0876 16.28 12.0489C16.48 11.0102 16.38 9.91158 15.98 8.93275C15.58 7.95392 14.88 7.11505 14 6.5158C13.12 5.91655 12.06 5.61693 11 5.61693L10.9999 3C11.3198 3 11.6398 3.01995 11.9799 3.05997C12.0199 3.05997 12.0799 3.07992 12.1199 3.07992C12.4399 3.11983 12.7599 3.19975 13.0599 3.27967L13.0599 3.27964Z"
      fill="white"
    />
    <path
      d="M7.17991 14.8052L5.33997 16.6428C5.83997 17.1422 6.37991 17.5617 7.00002 17.9213L8.30002 15.664C7.87993 15.4244 7.49991 15.1448 7.17994 14.8052L7.17991 14.8052Z"
      fill="white"
    />
    <path
      d="M10.2799 16.3433C10.04 16.3034 9.7999 16.2634 9.57993 16.2035L8.8999 18.7203C9.23984 18.8002 9.57993 18.8802 9.91987 18.9201C10.2799 18.96 10.6199 18.98 10.9598 19V16.4032C10.7599 16.3832 10.52 16.3632 10.2799 16.3433L10.2799 16.3433Z"
      fill="white"
    />
    <path
      d="M12.3799 16.2035C12.8399 16.0836 13.2799 15.9038 13.6799 15.6642L14.9799 17.9214C14.3799 18.2609 13.7399 18.5406 13.0599 18.7204L12.3799 16.2035Z"
      fill="white"
    />
    <path
      d="M5.77988 12.3882C5.89986 12.8477 6.07988 13.2871 6.31983 13.6866L4.05989 14.985C3.71994 14.3857 3.43992 13.7466 3.25989 13.0674L5.77988 12.3882Z"
      fill="white"
    />
    <path
      d="M8.29988 6.31583C8.69988 6.07617 9.13983 5.89638 9.59988 5.77656L8.91997 3.25973C8.23994 3.43953 7.6 3.71922 7 4.05873L8.29988 6.31583Z"
      fill="white"
    />
    <path
      d="M7.17993 7.17475C6.83999 7.51427 6.55996 7.87388 6.31988 8.29332L4.05994 6.99495C4.41999 6.3957 4.83996 5.83634 5.33996 5.33696L7.17993 7.17475Z"
      fill="white"
    />
    <path
      d="M3.05994 9.95128C3.09989 9.59167 3.17991 9.25215 3.25994 8.93258L5.77991 9.5917C5.71986 9.8114 5.67991 10.0512 5.63995 10.2908C5.6 10.5305 5.6 10.7703 5.6 10.9899H3C2.99989 10.6504 3.01998 10.2908 3.05993 9.9513L3.05994 9.95128Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style scoped></style>
